let color = {

}

color.brand = "#3D8ACE";
color.text = "white";

export const BRAND_PRIMARY = color.brand;
export const TEXT_COLOUR = color.text;
